import React from 'react'
import Box from '../Box'
import { ProgressDatePickerComponsition, ProgressProps } from './Progress.types'
import ProgressCircle from './ProgressCircle'
import ProgressRating from './ProgressRating'

const index: React.FC<ProgressProps> & ProgressDatePickerComponsition = ({
  color = 'red50',
  percent = 0,
  ...restProps
}) => {
  const renderPercentage = (percent: number) => {
    if (percent <= 0) {
      return 0
    }
    if (percent >= 100) {
      return 100
    }
    return percent
  }
  return (
    <Box
      position='relative'
      width='100%'
      height={8}
      borderRadius={100}
      backgroundColor='black5'
      {...restProps}
    >
      <Box
        position='relative'
        backgroundColor={color}
        height='100%'
        width={`${renderPercentage(percent)}%`}
        borderRadius={100}
      />
    </Box>
  )
}

index.Circle = ProgressCircle
index.Rating = ProgressRating

export default index
